import { Injectable } from '@angular/core';
import { CrudService } from 'app/shared/services/crud.service';
import { Spring } from '../constants/spring';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private crud: CrudService, private spring: Spring) { }


  singinUserToken(usuario:any){
    return this.crud.post(`${this.spring.SIGNIN_TOKEN}`, usuario );
  }

  singoutUserToken(refreshToken:any){
    return this.crud.post(`${this.spring.SIGNOUT_TOKEN}`, refreshToken );
  }

  refreshUserToken(refreshToken:any){
    return this.crud.get(`${this.spring.REFRESH_TOKEN}/${refreshToken}`);
  }


}
